"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    margin: 0 0 14px;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .fallback-message {\n    font-family: ", ";\n    color: ", ";\n    font-size: 14px;\n    text-align: center;\n    padding: 40px 0 20px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    margin: 0 0 14px;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .fallback-message {\n    font-family: ", ";\n    color: ", ";\n    font-size: 14px;\n    text-align: center;\n    padding: 40px 0 20px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map